import { useCallback } from 'react';
import {
  ORIGIN_LOCATION_TYPE,
  DESTINATION_LOCATION_TYPE,
} from '#/shared/constants';
import useCurrentQuery from '#/trip-planner/hooks/useCurrentQuery';
import useCurrentLocation from '#/shared/hooks/useCurrentLocation';

export default () => {
  const { setCurrentQueryParam, currentQuery } = useCurrentQuery();
  const { currentLocation } = useCurrentLocation();

  const isQueryComplete = useCallback(
    locType =>
      (currentQuery.to && locType === ORIGIN_LOCATION_TYPE) ||
      (currentQuery.from && locType === DESTINATION_LOCATION_TYPE),
    [currentQuery]
  );

  const currentQueryRedirect = useCallback(
    (locType, navigateToDefault, navigateToAlternative) => {
      if (isQueryComplete(locType)) {
        navigateToAlternative();
        return;
      }
      if (locType === DESTINATION_LOCATION_TYPE && currentLocation) {
        setCurrentQueryParam(ORIGIN_LOCATION_TYPE, currentLocation);
        navigateToAlternative();
        return;
      }
      navigateToDefault();
    },
    [currentLocation, isQueryComplete, setCurrentQueryParam]
  );
  return { currentQueryRedirect };
};
